import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { RemoveAllIcon } from '../Icons/Icons'
import BarButton from './BarButton'

import { groupsSelector, removeAllGroups } from '../../modules/reducerGroups'

const RemoveAllGroupsButton = () => {
  const groups = useSelector(groupsSelector)
  const dispatch = useDispatch()

  const handleRemoveAll = useCallback(() => {
    dispatch(removeAllGroups())
  }, [dispatch])

  return (
    <BarButton
      tooltipTitle={'Borrar todos'}
      tooltipEnabled
      disabled={groups.length === 0}
      onClick={handleRemoveAll}
    >
      <RemoveAllIcon />
    </BarButton>
  )
}
export default RemoveAllGroupsButton
